import React, { useState } from 'react';
import { Button, Col, Form, Modal, Row } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { AppDispatch } from '../../../../store/app';
import { useDispatch } from 'react-redux';
import { FormBox, InputBox } from '../../../../components/AntdAddons';
import SVGIcon from '../../../../utils/SVGIcon';
import dayjs, { Dayjs } from 'dayjs';
import { CONSTANT } from '../../../../config/Constant';
import { addNumberManagementNumberAttributesReport } from '../../../../store/NumberManagementNumberAttributesReportSlice';
import { validations } from '../../../../config/validations/validations';
import { addTotalNumberByAttributesReport } from '../../../../store/TotalNumberByAttributesReportSlice';

const AddNumberAttributesReport: React.FC<any> = (props) => {
  const { handleAddModal, openAddModal, getList } = props;

  const dispatch: AppDispatch = useDispatch();
  const [form] = Form.useForm();

  const [loading, setLoading] = useState<boolean>(false);

  const handleSubmit = (data) => {
    console.log('data: ', data);

    setLoading(true);

    dispatch(addTotalNumberByAttributesReport(data))
      .then((res: any) => {
        handleAddModal();
        getList();
      })
      .catch((error: any) => {
        console.log('error', error);

        // handleAddModal();
        // getList();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // for validation
  const handleChange = () => {
    form
      .validateFields()
      .then(() => {
        // setDisable(false);
      })
      .catch((error: any) => {
        // setDisable(true);
      });
  };

  const disabledDate = (current: Dayjs) => {
    // Can not select days after today
    return current && current.isAfter(dayjs().endOf('day'));
  };

  return (
    <Modal
      open={openAddModal}
      destroyOnClose
      width={900}
      onCancel={handleAddModal}
      closeIcon={<FontAwesomeIcon icon={faTimes} />}
      footer={false}
      className='addModal'
      title={`Add Total Number By Attributes Report`}
    >
      <FormBox
        className='filterForm'
        form={form}
        onFinish={handleSubmit}
        onChange={handleChange}
        validateTrigger={['onBlur', 'onInput']}
        autoComplete='off'
        initialValues={{ number_type: 'both' }}
      >
        <Row gutter={20} align={'middle'}>
          <Col xs={24} md={8}>
            <InputBox.Text
              label='Phone Number'
              name={'phone_number'}
              type='number'
              tooltip='Phone Number must be between 3 to 11 digits and start with 0 or 1.'
              required
              rules={[
                validations.required.text('Phone Number'),
                validations.pattern.numericWithSecial,
                validations.pattern.whitespace,
                validations.pattern.phoneNumberValidation,
              ]}
            />
          </Col>
          <Col xs={24} md={8}>
            <InputBox.Select
              label='Number Type'
              name={'number_type'}
              allowClear
              showSearch
              placeholder='Select Number Type'
              tooltip='Select Number Type'
              options={{
                list: [
                  {
                    id: 'mobile',
                    label: 'Mobile',
                  },
                  {
                    id: 'fixed',
                    label: 'Fixed',
                  },
                  {
                    id: 'both',
                    label: 'Both',
                  },
                ],
                valueKey: 'id',
                textKey: 'label',
              }}
            />
          </Col>
          <Col xs={24} md={8}>
            <InputBox.Select
              label='State'
              name='state'
              allowClear
              showSearch
              placeholder='Select State'
              tooltip='Select State'
              options={{
                list: [
                  { id: 'available', label: 'Available' },
                  { id: 'in use for client', label: 'In Use for Client' },
                  { id: 'in use internal', label: 'In Use Internal' },
                  { id: 'reserved for client', label: 'Reserved for Client' },
                  { id: 'freezed by client', label: 'Freezed by Client' },
                  { id: 'freezed account', label: 'Freezed Account' },
                  { id: 'ported', label: 'Ported' },
                ],
                valueKey: 'id',
                textKey: 'label',
              }}
            />
          </Col>

          <Col xs={24} md={8}>
            <InputBox.Select
              label='Payment Type'
              name='payment_type'
              allowClear
              showSearch
              placeholder='Select Payment Type'
              tooltip='Select Payment Type'
              options={{
                list: [
                  { id: 'prepaid', label: 'Prepaid' },
                  { id: 'postpaid', label: 'Postpaid' },
                ],
                valueKey: 'id',
                textKey: 'label',
              }}
            />
          </Col>

          <Col xs={24} md={8}>
            <InputBox.Select
              label='Service Type'
              name='service_type'
              allowClear
              showSearch
              placeholder='Select Service Type'
              tooltip='Select Service Type'
              options={{
                list: [
                  { id: 'M2M/IoT', label: 'M2M/IoT' },
                  { id: 'regular', label: 'Regular' },
                  { id: 'kosher', label: 'Kosher' },
                  { id: 'data only', label: 'Data Only' },
                  { id: 'irrelevant', label: 'Irrelevant' },
                ],
                valueKey: 'id',
                textKey: 'label',
              }}
            />
          </Col>

          <Col xs={24} md={8}>
            <InputBox.Select
              label='Subscription Type'
              name='subscription_type'
              allowClear
              showSearch
              placeholder='Select Subscription Type'
              tooltip='Select Subscription Type'
              options={{
                list: [
                  { id: 'business', label: 'Business' },
                  { id: 'private', label: 'Private' },
                  { id: 'splitted business', label: 'Splitted Business' },
                  { id: 'irrelevant', label: 'Irrelevant' },
                ],
                valueKey: 'id',
                textKey: 'label',
              }}
            />
          </Col>
        </Row>
        <Row gutter={[20, 20]} className='mt-20'>
          <Col xs={12} md={12} lg={6}>
            <Button type='primary' htmlType='submit' loading={loading}>
              <SVGIcon icon='add' color='#fff' width={55} /> Add Report
            </Button>
          </Col>
          <Col xs={12} md={12} lg={6}>
            <Button
              type='default'
              onClick={() => {
                form.resetFields();
                // if (typeAction === "daily") {
                //   form.setFieldsValue({ report_date: dayjs(new Date()) });
                // }
              }}
            >
              Clear
            </Button>
          </Col>
        </Row>
      </FormBox>
    </Modal>
  );
};

export default AddNumberAttributesReport;
